import React from 'react';
import { IconLoader2 } from '@tabler/icons-react';

const defaultIcon = (
  <IconLoader2 className="table-loading-icon" size={40} stroke={1.5} />
);

/**
 * Centered loading card for admin list views (school / subscription).
 */
export function TableLoadingCard({ icon, label = 'Loading' }) {
  return (
    <div className="table-loading-card-wrap" role="status" aria-label={label}>
      <div className="table-loading-card">
        {icon || defaultIcon}
        <div className="table-loading-dots">
          <span className="table-loading-dot" />
          <span className="table-loading-dot" />
          <span className="table-loading-dot" />
        </div>
      </div>
    </div>
  );
}

export function TableLoadingRow(props) {
  return <TableLoadingCard {...props} />;
}

export default TableLoadingCard;
